import { object, string } from "yup";

export const validationSchema = object().shape({
  emailAddress: string()
    .required("Email address is required")
    .email("Please enter a valid email address")
    .trim(),
});
